"use strict";
// reference: https://developers.braintreepayments.com/guides/paypal/client-side/javascript/v3
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var app_1 = require("../app");
var payment_1 = require("../steps/payment");
var useContext = React.useContext, useEffect = React.useEffect, useState = React.useState;
var paypalButtonContainerId = 'paypal-container';
exports.default = (function () {
    var context = useContext(app_1.CheckoutContext);
    var paymentContext = useContext(payment_1.PaymentContext);
    if (!context || !paymentContext)
        return null;
    var imageUrls = context.imageUrls, paymentMethod = context.paymentMethod, paymentInfo = context.paymentInfo, setPaymentInfo = context.setPaymentInfo, setPaymentValid = context.setPaymentValid, paypalCheckout = context.paypalCheckout, dataLayerPushEvent = context.dataLayerPushEvent;
    var setPaymentMethodFromEvent = paymentContext.setPaymentMethodFromEvent;
    var paypalEffect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var paypal;
        return __generator(this, function (_a) {
            paypal = window.paypal // TODO: get proper paypal typing
            ;
            if (!paypalCheckout || !paypal)
                return [2 /*return*/, null
                    // render the paypal button on the page
                ];
            // render the paypal button on the page
            paypal
                .Buttons({
                fundingSource: paypal.FUNDING.PAYPAL,
                createBillingAgreement: function () {
                    dataLayerPushEvent('checkout__paypalPaymentMethodInitiated', {});
                    return paypalCheckout.createPayment({
                        flow: 'vault',
                        enableShippingAddress: true,
                    });
                },
                onApprove: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                    var payload;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, paypalCheckout.tokenizePayment(data)];
                            case 1:
                                payload = _a.sent();
                                console.log('paypal payloads', data, payload);
                                dataLayerPushEvent('checkout__paypalPaymentMethodApproved', {});
                                setPaymentInfo({ token: payload.nonce, email: payload.details.email, cardType: 'paypal' });
                                setPaymentValid(true);
                                return [2 /*return*/];
                        }
                    });
                }); },
                style: {
                    height: 48,
                },
            })
                .render("#".concat(paypalButtonContainerId));
            return [2 /*return*/];
        });
    }); };
    var disconnectPaypal = function () {
        setPaymentInfo(undefined);
        setPaymentValid(false);
    };
    useEffect(function () {
        paypalEffect();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: ' grid-x padding-left-4 padding-4' },
            React.createElement("div", { className: 'cell small-2  medium-1' },
                React.createElement("input", { type: 'radio', checked: paymentMethod === 'paypal', id: 'payment-method-paypal', value: 'paypal', onChange: setPaymentMethodFromEvent })),
            React.createElement("div", { className: 'cell small-10' },
                React.createElement("h5", { className: 'font-lighter' },
                    React.createElement("label", { htmlFor: 'payment-method-paypal', style: { display: 'inline' } }, "Paypal"),
                    React.createElement("div", { className: 'float-right' },
                        React.createElement("img", { src: imageUrls.paypal }))))),
        React.createElement("div", { className: (0, classnames_1.default)({ 'animated-container': true, 'closed-immediately': paymentMethod !== 'paypal' }) },
            React.createElement("div", { className: 'horizontal-divider-very-light-pink' }),
            React.createElement("div", { className: 'padding-4 bg-almost-white' },
                (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.email) && (React.createElement("div", { className: 'flex-container justify-between font-lighter h7 align-middle' },
                    React.createElement("div", null,
                        "Connected as ",
                        paymentInfo.email,
                        " "),
                    "\u00A0\u00A0",
                    React.createElement("div", null,
                        React.createElement("a", { href: 'javascript:void(0)', className: 'button bg-white text-black tiny border-black', onClick: disconnectPaypal }, "Remove")))),
                React.createElement("div", { className: (0, classnames_1.default)({ hide: paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.email }) },
                    React.createElement("span", { className: 'h7 margin-bottom-3' }, "Click here to begin Paypal Checkout"),
                    React.createElement("div", { id: paypalButtonContainerId, style: { width: 157 } }))))));
});
